import React from 'react'

import { Textarea } from '#base/js/common/components/textarea'
import { usePageEditorContext } from '../../contexts/page-editor.context'

import { useStyles } from './plaintext-block-edit-sidebar.style'

export const PlainTextBlockEditSidebar = function ({ name, required, placeholder } = {}) {
  const classes = useStyles()

  const pageEditorContext = usePageEditorContext() || {}
  const { page, currentEdit = {} } = pageEditorContext || {}

  function handleTextChange (event) {
    if (event.target && pageEditorContext.setCurrentEdit) {
      const value = event.target.value
      pageEditorContext.setCurrentEdit({ ...currentEdit, [name]: value, isValid: !required || value.length > 0 })
      pageEditorContext.registerUnsavedChanges()
    }
  }

  return (
    <div className={classes.textAreaContainer}>
      <Textarea
        value={currentEdit[name] !== undefined ? currentEdit[name] : page[name]}
        onChange={handleTextChange}
        data-qa={`page-${name}-input`}
      />
    </div>
  )
}
